import { usePopper } from '@chakra-ui/popper';
import { useEffect, useMemo, ReactNode } from 'react';
import type { XYCoord } from 'react-dnd';

import { Box, DragSummary as CoreDragSummary } from '@frontend/components';

import { OFFSET_FROM_CURSOR_IN_PX } from './const';
import { getTransform } from './util';

export type CustomDragSummaryProps = {
  clientOffset: XYCoord;
  draggedItemDescription: ReactNode;
};

export const CustomDragSummary = ({
  clientOffset,
  draggedItemDescription,
}: CustomDragSummaryProps) => {
  const transform = getTransform(clientOffset);

  const { referenceRef, popperRef, update } = usePopper({
    placement: 'right-start',
    gutter: 0,
    modifiers: [
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['left-start'],
        },
      },
    ],
  });

  const { x: offsetX, y: offsetY } = clientOffset;

  useEffect(() => {
    update();
  }, [update, offsetX, offsetY]);

  const dragSummaryContent = useMemo(
    () => <CoreDragSummary draggedItemDescription={draggedItemDescription} />,
    [draggedItemDescription],
  );

  return (
    <>
      <Box
        ref={referenceRef}
        height={0}
        width={`${OFFSET_FROM_CURSOR_IN_PX * 2}px`}
        transform={transform}
        transformOrigin="center"
      />
      <Box ref={popperRef}>{dragSummaryContent}</Box>
    </>
  );
};
